import script from './SdsInputPassword.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SdsBaseInput',{staticClass:"sds-input-password",attrs:{"name":_vm.name,"value":_vm.value,"label":_vm.label,"isDisabled":_vm.isDisabled,"isReadOnly":_vm.isReadOnly,"message":_vm.message,"status":_vm.status,"autocomplete":_vm.autocomplete,"dataTestId":_vm.dataTestId,"type":_vm.inputType},on:{"update:value":function($event){return _vm.$emit('update:value', $event)},"focus":function($event){return _vm.$emit('focus', $event)},"blur":function($event){return _vm.$emit('blur', $event)},"click":function($event){return _vm.$emit('click', $event)},"keydown":function($event){return _vm.$emit('keydown', $event)},"keypress":function($event){return _vm.$emit('keypress', $event)},"keyup":function($event){return _vm.$emit('keyup', $event)},"cleared":function($event){return _vm.$emit('cleared')}},scopedSlots:_vm._u([{key:"append",fn:function(){return [_c('SdsButtonIcon',{attrs:{"iconName":_vm.inputType === 'password' ? 'toggle-view' : 'toggle-view-off',"hasContainer":false,"size":"sm"},on:{"click":_vm.toggleInputType}})]},proxy:true},(_vm.passwordStrength != null)?{key:"message:prepend",fn:function(){return [_c('SdsPasswordStrength',{staticClass:"sds-input-password__strength",attrs:{"passwordStrength":_vm.passwordStrength}})]},proxy:true}:null],null,true)})};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-6ac3c995_0", { source: ".sds-input-password__strength[data-v-6ac3c995]{margin-top:4px}[data-v-6ac3c995]::-ms-reveal{display:none}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-6ac3c995";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
